import AutocompleteLib from '@atpoint/atpjs/components/autocomplete'
import { withStyles } from '@material-ui/styles'
import { useTracking } from 'swisscard/components/form/hooks/use_tracking'
import { autocompleteStyles } from './autocomplete_styles'

import type { AutocompletePropsType } from '@atpoint/atpjs/components/autocomplete'
import type { ClassNameMap } from '@material-ui/styles'
import type { TrackingProps } from '../../../tracking/types'

// biome-ignore lint/nursery/useComponentExportOnlyModules: keeping this pattern.
const Autocomplete = (props: AutocompletePropsType & TrackingProps & { classes: ClassNameMap }) => {
  const inputProps = useTracking(props, { event: 'formInteraction', action: 'onBlur' })

  const { classes } = inputProps

  const styleProps = {
    // style classes for the input field
    errorClassName: classes.errorMessage,
    labelClassName: classes.labelDefault,
    infoBottomClassName: classes.infoBottom,
    inputClassName: `${classes.inputDefault} ${classes.inputSearch}`,
    optionalClassName: classes.optional,
    wrapperClassName: classes.inputWrapper,

    // styles classes for the suggestions list
    listClassName: classes.listClassName,
    listClassNameNoResults: classes.listClassNameNoResults,
    listEntryClassName: classes.listEntryClassName,
    listEntryClassNameNoResults: classes.listEntryClassNameNoResults,
    selectedEntryClassName: classes.selectedEntryClassName,
  }

  return <AutocompleteLib {...inputProps} {...styleProps} />
}

export default withStyles(autocompleteStyles)(Autocomplete)
